import React from 'react';

const Masonry = ({
  items,
  onItemClick // 🚀 完美接收外部的点击放大指令
}) => {
  return (
    // 使用 Tailwind 的多列布局 (瀑布流核心)，自动响应式
    <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6 px-4">
      
      {items.map((item) => (
        <div 
          key={item.id} 
          className="break-inside-avoid w-full overflow-hidden rounded-xl relative group transition-all duration-500 hover:scale-[0.98] hover:shadow-[0_0_40px_rgba(0,255,150,0.15)] cursor-pointer border border-white/5"
          // 根据传入的数据自动设定高矮比例
          style={{ height: item.height }} 
          // 🚀 核心：点击整个卡片都会触发放大播放！
          onClick={() => {
            if (onItemClick) {
              onItemClick(item);
            }
          }}
        >
         {/* 视频渲染层 */}
          <video
            src={item.videoUrl}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            playsInline
            loop
            muted
            preload="metadata"
            onMouseEnter={(e) => {
              // 🚀 核心优化：让播放变成一个带有“错误捕获”的安全动作
              const playPromise = e.target.play();
              if (playPromise !== undefined) {
                playPromise.catch(() => {
                  // 如果鼠标移开太快导致播放被打断，静默处理，不再红屏报错！
                });
              }
            }}
            onMouseLeave={(e) => {
              e.target.pause();
            }}
          />
          
          {/* 高级交互：鼠标悬浮时出现的暗色渐变遮罩和文字 */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none flex items-end p-6 md:p-8">
            <div className="translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
              <div className="flex items-center gap-3 mb-2">
                <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
                <span className="text-emerald-400 font-mono text-xs tracking-widest uppercase">
                  {item.type === 'horizontal' ? 'Landscape' : 'Portrait'}
                </span>
              </div>
              <h3 className="text-white text-xl md:text-2xl font-bold tracking-wide">
                {item.title || 'Visual Effects Sequence'}
              </h3>
            </div>
          </div>

          {/* 悬浮时的播放小图标提示 */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-black/40 backdrop-blur-md rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 scale-50 group-hover:scale-100 border border-white/20 pointer-events-none">
            <svg className="w-8 h-8 text-white translate-x-0.5" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
          </div>

        </div>
      ))}

    </div>
  );
};

export default Masonry;